import { Box, Button, Stack } from '@mui/material'
import { useState } from 'react'
import TabulatedDataView from '../../common/TabulatedDataView'
import { TDataField, TEntryField } from '../../data/ProcData'
import { TTimelineStep } from '../../data/WorkflowSteps'
import { updateActionLogsAsync } from '../admin/common/FetchApi'
import { DataFormNumberField } from '../run/DataNumberField'
import { useAppDispatch, useAppSelector } from './monitorReduxHooks'
import { selectTransposed, setfield } from './sliceMonitorData'
import { selectProcHeader } from './sliceMonitorProcHeader'

export default function TabTabulated() {
    const d = useAppSelector(selectTransposed)

    const [fieldToEdit, setFieldToEdit] = useState<{step: TTimelineStep, field: TDataField, value: number | undefined} | null>(null)
    const readonlyHeader = useAppSelector(selectProcHeader)


    const dispatch = useAppDispatch()

    /* if we want to edit the fields
    const editField = (step: TTimelineStep, field: TDataField) => {
        if (fieldToEdit === null ) {
            if (!CalculatedFields.includes(field as TCalculatedField)) {
                const value = data[step][field] as number | undefined
                setFieldToEdit({step, field, value})
            }
        }
    }
    */

    // If no editing just do nothing
    const editField = (step: TTimelineStep, field: TDataField) => {
    }

    const onFieldChanged = (field: TEntryField, newValue: number | undefined) => {
        const cpy = {...fieldToEdit!}
        cpy.value = newValue!
        setFieldToEdit(cpy)
    }

    const onFinishEditClick = () => {
        if (fieldToEdit!.value) {

            dispatch(setfield({
                fieldName: fieldToEdit!.field as TEntryField, 
                step: fieldToEdit!.step, 
                value: fieldToEdit!.value}))
            const proc_id = JSON.stringify({partitionKey: readonlyHeader?.partitionKey, rowKey: readonlyHeader?.rowKey})
            const email = readonlyHeader?.performedBy
            updateActionLogsAsync(email?email:'', proc_id, JSON.stringify(fieldToEdit))
        }
        setFieldToEdit(null)
    }

    return (
        d === undefined
            ? <>'Loading data'</>
            :   <>
                    <TabulatedDataView data={d}  editFieldCallback={editField}/>
                    {fieldToEdit
                        ? <Stack direction='row' mt='15px' height={'30px'} sx={{justifyContent:'center'}} >
                            <DataFormNumberField sx={{width:'500px'}}
                                initialValue={fieldToEdit.value as number | undefined} 
                                field={fieldToEdit.field as TEntryField}
                                onDictionaryFieldChange = {onFieldChanged} />
                            <Box width={'100px'}/>
                            <Button sx={{mt:'30px'}} onClick={() => setFieldToEdit(null)}>Cancel</Button>
                            <Button sx={{mt:'30px'}} onClick={onFinishEditClick}>OK</Button>
                        </Stack>
                        : null
                    }
                </>
    )
}
